import type { LibraryTemplate } from "../library";
import { ellipse, logo, photo, pill, rect, stack, t, text } from "./shorthands";

/** LinkedIn. */
const FIRST_LINKEDIN: LibraryTemplate[] = [
  {
    id: "linkedin-neuigkeit",
    title: "LinkedIn: Neuigkeit",
    description: "Querformat mit Foto rechts und Schlagzeile links",
    presetId: "linkedin-landscape",
    topic: "ankuendigung",
    style: "klar",
    pages: [
      {
        background: "secondary",
        nodes: [
          photo({ x: 640, y: 0, w: 440, h: 564 }),
          rect({ x: 620, y: 0, w: 20, h: 564, fill: "accent", name: "Linie" }),
          logo({ x: 60, y: 44, w: 220, h: 52, on: "secondary" }),
          stack({
            x: 60,
            y: 300,
            w: 520,
            anchor: "center",
            gap: 18,
            items: [
              t("NEUIGKEIT", "subline", 24, "accent"),
              t(
                "Wir eröffnen unseren zweiten Standort in Hamburg",
                "heading-1",
                52,
                "on:secondary",
              ),
            ],
          }),
          text({
            text: "beispiel.de",
            style: "caption",
            size: 22,
            color: "on:secondary/70",
            x: 60,
            y: 480,
            w: 400,
          }),
        ],
      },
    ],
  },
  {
    id: "linkedin-webinar",
    title: "LinkedIn: Webinar",
    description: "Einladung mit Termin und Porträt der Sprecherin",
    presetId: "linkedin-landscape",
    topic: "event",
    style: "verspielt",
    pages: [
      {
        background: "background",
        nodes: [
          ellipse({ x: 700, y: -60, w: 460, h: 460, fill: "primary/15", name: "Kreis" }),
          photo({ x: 760, y: 110, w: 280, h: 280, ellipse: true, fill: "primary/30" }),
          ...pill(60, 60, 190, 52, "WEBINAR", "primary", 22),
          stack({
            x: 60,
            y: 150,
            w: 620,
            gap: 24,
            items: [
              t("Social Media für kleine Unternehmen", "heading-1", 56, "text"),
              t("Do, 14. November · 17:00 Uhr · online & kostenlos", "body", 26, "text-muted"),
            ],
          }),
          stack({
            x: 740,
            y: 412,
            w: 320,
            gap: 4,
            align: "center",
            items: [
              t("Mit Lena Berger", "subline", 24, "text"),
              t("Marketing-Leitung", "caption", 20, "text-muted"),
            ],
          }),
          logo({ x: 60, y: 470, w: 200, h: 56, on: "background" }),
        ],
      },
    ],
  },
];

const MORE_LINKEDIN: LibraryTemplate[] = [
  {
    id: "linkedin-karriere",
    title: "LinkedIn: Wir stellen ein",
    description: "Stellenanzeige im Querformat mit Foto, Eckdaten und Bewerben-Button",
    presetId: "linkedin-landscape",
    topic: "team",
    style: "klar",
    tags: ["job", "karriere", "stellenanzeige", "recruiting", "bewerbung", "hiring", "personal"],
    pages: [
      {
        background: "primary",
        nodes: [
          photo({ x: 700, y: 0, w: 380, h: 564 }),
          ...pill(60, 50, 250, 50, "WIR STELLEN EIN", "accent", 20),
          text({
            text: "Senior Projektmanager:in (m/w/d)",
            style: "heading-1",
            size: 52,
            color: "on:primary",
            x: 60,
            y: 130,
            w: 590,
            h: 170,
          }),
          text({
            text: "Hamburg oder remote · Vollzeit · ab sofort",
            style: "body",
            size: 24,
            color: "on:primary/85",
            x: 60,
            y: 315,
            w: 590,
          }),
          ...pill(60, 390, 280, 62, "Jetzt bewerben", "background", 24),
          logo({ x: 60, y: 490, w: 200, h: 50, on: "primary" }),
        ],
      },
    ],
  },
  {
    id: "linkedin-zitat",
    title: "LinkedIn: Zitat",
    description: "Porträt links, Zitat mit Namen rechts – für Statements und Thought Leadership",
    presetId: "linkedin-landscape",
    topic: "zitat",
    style: "elegant",
    tags: ["zitat", "statement", "thought leadership", "meinung", "ceo", "gedanke", "porträt"],
    pages: [
      {
        background: "surface",
        nodes: [
          ellipse({ x: 30, y: 72, w: 420, h: 420, fill: "primary/15", name: "Kreis" }),
          photo({ x: 60, y: 102, w: 360, h: 360, ellipse: true, fill: "primary/25" }),
          text({
            text: "“",
            style: "quote",
            size: 160,
            color: "accent",
            x: 480,
            y: 40,
            w: 200,
          }),
          text({
            text: "Gute Führung heißt, anderen den Raum zu geben, über sich hinauszuwachsen.",
            style: "quote",
            size: 40,
            color: "text",
            x: 490,
            y: 150,
            w: 540,
            h: 220,
          }),
          stack({
            x: 490,
            y: 400,
            w: 540,
            gap: 4,
            items: [
              t("Dr. Anna Schulz", "subline", 26, "text"),
              t("Geschäftsführerin, Beispiel GmbH", "caption", 20, "text-muted"),
            ],
          }),
          logo({ x: 830, y: 490, w: 200, h: 44, on: "surface", align: "right" }),
        ],
      },
    ],
  },
];

export const LINKEDIN: LibraryTemplate[] = [...FIRST_LINKEDIN, ...MORE_LINKEDIN];
